import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Rect, { width: "12", height: "20", x: "6", y: "2", rx: "2", stroke: `${color}` })
    }
  );
};
Icon.displayName = "RectangleVertical";
const RectangleVertical = memo(themed(Icon));
export {
  RectangleVertical
};
//# sourceMappingURL=rectangle-vertical.js.map
